import { ManageMedia, MediaManagerState } from "./ManageMedia";

export class ManageScreenshots extends ManageMedia {

    componentDidMount() {
        this.props.fetchMediaItems(this.payload, false);
    }

    componentDidUpdate(prevProps: any, prevState: MediaManagerState) {
        let oldMediaData = prevProps.hydrationStates.screenshots.mediaData;
        let newMediaData = this.props.hydrationStates.screenshots.mediaData;
        if (newMediaData && newMediaData !== oldMediaData) {
            this.payload.continuationToken = newMediaData.continuationToken;
            if (!oldMediaData || newMediaData.values !== oldMediaData.values) {
                this.updateList(newMediaData.values, false);
            } else if (newMediaData.values.length === 0) {
                this.updateList([], false);
            }
        }
        if (this.state.filterOrder !== prevState.filterOrder && newMediaData) {
            this.updateList(newMediaData.values, false);
        }
    }

    loadMoreMedia = () => {
        this.props.fetchMediaItems(this.payload, false);
    }
}
